const hasChildren = children => {
  if (!children) return false;
  const isChildrenArray = Array.isArray(children);
  if (!isChildrenArray) {
    return !!(
      Object.keys(children).length &&
      children.props &&
      children.props.children &&
      children.props.children.length > 1
    );
  }
  return isChildrenArray && !!children.length;
};

export default hasChildren;
